import { RpcTransport } from '@wiko/rpc-spec';
import { parseJsonWithBigInts, stringifyJsonWithBigints } from '@wiko/rpc-spec-types';
import type Dispatcher from 'undici-types/dispatcher';

import { createHttpTransport } from './http-transport';
import { AllowedHttpRequestHeaders } from './http-transport-headers';
import { isWikoRequest } from './is-wiko-request';

type Config = Readonly<{
    dispatcher_NODE_ONLY?: Dispatcher;
    headers?: AllowedHttpRequestHeaders;
    url: string;
}>;

export function createHttpTransportForWikoRpc(config: Config): RpcTransport {
    return createHttpTransport({
        ...config,
        fromJson: (rawResponse: string, payload: unknown) =>
            isWikoRequest(payload) ? parseJsonWithBigInts(rawResponse) : JSON.parse(rawResponse),
        toJson: (payload: unknown) =>
            isWikoRequest(payload) ? stringifyJsonWithBigints(payload) : JSON.stringify(payload),
    });
}
